import { getExtensionListForSSR } from '@atlassian/forge-ui/provider';
import { preloadSpaceDetail } from '@confluence/space-utils';
import { getUseExtensionListOptions } from './getUseExtensionListOptions';
import { query } from '@confluence/query-preloader-tools';

export const getExtensions = async ({
	spaceKey,
	cloudId,
	activationId,
	locale,
	hasAccessNarrowingSupport,
	expandAppOwner,
	moduleType,
	queryOptions,
	skip,
	skipFilter,
}) => {
	const { data } = await preloadSpaceDetail(spaceKey);
	const dataClassificationTags = data?.space?.dataClassificationTags;

	return getExtensionListForSSR({
		...getUseExtensionListOptions({
			cloudId,
			activationId,
			locale,
			dataClassificationTags,
			hasAccessNarrowingSupport,
			expandAppOwner,
			moduleType,
			queryOptions,
			skip,
			skipFilter,
		}),
		queryFn: query,
	});
};
